(function(){

    document.addEventListener('click', function(e) {
        const activeOnes = document.querySelectorAll('[data-adev-dropdown="item-wrap"].active');
        activeOnes.forEach(function(wrap) {
            if (!wrap.contains(e.target)) {
                wrap.classList.remove('active');
            }
        });
    });

    document.querySelectorAll('[data-adev-dropdown="wrap"]:not(.adev-init)').forEach(function(wrap) {

        const itemWrapEl = wrap.querySelector('[data-adev-dropdown="item-wrap"]');
        const selectedEl = wrap.querySelector('[data-adev-dropdown="item-selected"]');
        const itemOptionWrapEl = wrap.querySelector('[data-adev-dropdown="item-options"]');
        const itemOptionsEl = wrap.querySelectorAll('[data-adev-dropdown="item-option"]');

        selectedEl.addEventListener('click', function(e) {
            e.preventDefault();

            const activeOnes = document.querySelectorAll('[data-adev-dropdown="item-wrap"].active');
            activeOnes.forEach(function(activeOne) {
                if (activeOne !== itemWrapEl) {
                    activeOne.classList.remove('active');
                }
            });

            if (itemWrapEl.classList.contains('active')) {
                itemWrapEl.classList.remove('active');
            } else {
                itemWrapEl.classList.add('active');
            }
        });

        itemOptionsEl.forEach(function(itemOption) {
            itemOption.addEventListener('click', function(e) {
                e.preventDefault();

                const value = itemOption.getAttribute('value');

                const selectorEl = wrap.querySelector('[data-adev-dropdown="selector"]');

                if (selectorEl) {
                    const optionEl = selectorEl.querySelector(`option[value="${value}"]`);
                    if (optionEl) {
                        const optionValue = optionEl.getAttribute('value');
                        
                        selectorEl.value = optionValue;
                        selectorEl.dispatchEvent(new Event('change', { bubbles: true }));
                    }
                }

                const selectedOptionEl = itemWrapEl.querySelector('[data-adev-dropdown="item-option"][selected]');
                if (selectedOptionEl) {
                    selectedOptionEl.removeAttribute('selected');
                }

                selectedEl.innerHTML = itemOption.innerHTML;
                itemOption.setAttribute('selected', 'selected');
                itemWrapEl.classList.remove('active');
            });
        });

        wrap.classList.add('adev-init');
    });

})();